import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Base } from '@base/base';
import { firstValueFrom } from 'rxjs';
import { BaseComponent } from 'src/app/@base/base.component';
import { EnumRootPages } from '@enums/rootPages';
import { LogService } from 'src/app/services/log.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent<T> {

  public dialogRef = inject(MatDialogRef<T>)
  public logService = inject(LogService);

  @Input() title: string;
  @Input() buttons: boolean = true;
  @Input() disableButtonClose: boolean = false;

  constructor() { }

  public onClose(event?: any): void {
    this.dialogRef.close(event)
  }

  public onSubmit(event?: any): void {
    this.dialogRef.close(event)
  }

  public logFeature(message: string, product: EnumRootPages) : void{
    firstValueFrom(this.logService.createLog({
      description: message,
      product: product
    }))
  }
}
